import {Directive} from '@angular/core';
import {CheckboxControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Directive({
    selector: '[ngChkboxDefaultControl]',
    standalone: true,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: MwcCheckboxControlValueAccessorDirective,
        multi: true
    }]
})
export class MwcCheckboxControlValueAccessorDirective extends CheckboxControlValueAccessor {
}
